<form id="meetingForm" [formGroup]="meetingForm" *ngIf="meetingForm">
	<!-- (ngSubmit)="submitForm()"  -->
	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="inputMeetingDate" class="form-label theme-main-color fw-bold"
				>Date</label
			>
			<input
				autocomplete="off"
				type="text"
				bsDatepicker
				class="form-control"
				id="inputMeetingDate"
				formControlName="date"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg-6">
			<label class="form-label theme-main-color fw-bold">Heure de début</label>
			<timepicker
				[showMeridian]="false"
				[showSpinners]="false"
				[formControlName]="'readyTimeAsDate'"
				class="bg-transparent border-light ps-0"
			>
			</timepicker>
		</div>
		<div class="col-12 col-lg-6">
			<label class="form-label theme-main-color fw-bold">Heure de fin</label>
			<timepicker
				[showMeridian]="false"
				[showSpinners]="false"
				[formControlName]="'dueTimeAsDate'"
				class="bg-transparent border-light ps-0"
			>
			</timepicker>
		</div>
	</div>

	<!-- PARTICIPANTS -->
	<div class="row">
		<div class="col">
			<label class="form-label theme-main-color fw-bold">Participants</label>
			<br />
			<span
				class="d-inline-block bg-light rounded border border-1 theme-main-border-color thumbnail m-1"
				*ngFor="let p of this.synchronizedEvent.attendees"
			>
				<span class="m-2 theme-main-color">{{
					p.firstName + ' ' + p.lastName
				}}</span>
				<button
					class="btn-sm"
					(click)="removeParticipant(p)"
					[disabled]="p.id === user?.employee.id"
					[ngClass]="{
						'theme-red-button': p.id !== user?.employee.id,
						'theme-green-button': p.id === user?.employee.id
					}"
				>
					<i
						class="bi bi-x-lg"
						*ngIf="p.id !== user?.employee.id"
						aria-hidden="true"
					></i>
					<i
						class="bi bi-pin-fill"
						aria-hidden="true"
						*ngIf="p.id === user?.employee.id"
					></i>
				</button>
			</span>
			<div class="row pb-5">
				<div class="col-9 mt-3 mb-3">
					<input
						*ngIf="user?.role.id !== Authority.CHARGE_MISSION"
						autocomplete="off"
						[ngModelOptions]="{ standalone: true }"
						[typeahead]="listEmployeeMapped"
						typeaheadOptionField="name"
						[typeaheadItemTemplate]="itemTemplateTypeaheadEmployeeReunion"
						[typeaheadMinLength]="0"
						placeholder="Entrez un intervenant à ajouter"
						class="form-control"
						[typeaheadScrollable]="true"
						(typeaheadOnSelect)="typeaheadEmployeeOnSelectForReunion($event)"
						[(ngModel)]="selectedParticipant"
					/>
					<ng-template
						#itemTemplateTypeaheadEmployeeReunion
						let-model="item"
						let-index="index"
					>
						<span *ngIf="user?.role.id !== Authority.CHARGE_MISSION">{{
							model.name
						}}</span>
					</ng-template>
				</div>
				<div class="col mt-3 mb-3">
					<button
						type="button"
						class="btn theme-main-color-button"
						(click)="selectAllParticipants()"
						*ngIf="
							this.synchronizedEvent.attendees.length !== listEmployee?.length
						"
					>
						Tous
					</button>
					<button
						type="button"
						class="btn theme-main-color-button"
						(click)="resetParticipants()"
						*ngIf="
							this.synchronizedEvent.attendees.length === listEmployee?.length
						"
					>
						Effacer
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- NOTES -->
	<div class="row my-4">
		<div class="col">
			<label for="inputNotes" class="form-label theme-main-color fw-bold"
				>Notes</label
			>
			<textarea
				class="form-control"
				id="inputNotes"
				formControlName="notes"
				[ngClass]="{
					'is-invalid': notes.invalid,
					'is-valid': notes.dirty && notes.valid
				}"
			></textarea>
			<div
				*ngIf="notes.invalid && (notes.dirty || notes.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="notes.errors?.maxlength">Taille maximale atteinte</span>
			</div>
		</div>
	</div>
</form>
